import { setContext } from '@apollo/link-context';
import { ApolloLink, HttpLink } from '@apollo/client';

export const createAppSyncHttpLink = function ({ appSyncApiUrl, getJwtToken }) {
  const authorizationHeaderLink = setContext(async (request, previousContext) => ({
    ...previousContext,
    headers: {
      ...previousContext.headers,
      Authorization: await getJwtToken(),
      ...(!(await getJwtToken()) && { 'x-api-key': process.env.REACT_APP_APOLLO_API_KEY }),
    }
  }));

  return ApolloLink.concat(
    authorizationHeaderLink as any,
    new HttpLink({ uri: appSyncApiUrl })
  );
};
